type AnalyticsParams = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export const trackEvent = (eventName: string, params: AnalyticsParams = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", eventName, params);
};

export const SIGNUP_STEPS = {
  1: "dream_home",
  2: "party",
  3: "journey",
  4: "love_from_u4u",
  5: "grade",
  6: "location",
  7: "contact",
  8: "create_account",
} as const;

export type SignupStepNumber = keyof typeof SIGNUP_STEPS;

export const trackSignupStepView = (stepNumber: SignupStepNumber) => {
  // One event name per step so counts show in GA4's standard Events report
  // without registering custom dimensions.
  trackEvent(`signup_step_${stepNumber}`, {
    step_name: SIGNUP_STEPS[stepNumber],
  });
};
